import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22Footer.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../../public/Jennifer%20Lynne%20Bold.ttf%22}],%22variableName%22:%22myFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'myFont', 'myFont Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
